/**
 * Checks whether the given entity is an activated activity or a folder that
 * contains an activated activity.
 * @param {Object} entity The entity to check.
 * @return {boolean} If entity is an activity, whether the activity is activated.
 *  If the entity is a folder, whether there's an activated activity anywhere in
 *  the nested hierarchy.
 */
export default function (entity) {
  return entity.current ||
    entity.activated ||
    entity.contains_activated_activity
}
